import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BoardSidebar from '../components/BoardSidebar';
import BoardContent from '../components/BoardContent';
import PostDetailPage from './PostDetailPage';
import PostWritePage from './PostWritePage';
import './BoardPage.css';

const BoardPage = () => {
  const { boardId, postId } = useParams();
  const navigate = useNavigate();
  
  const [currentBoard, setCurrentBoard] = useState(boardId || 'free');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  
  // URL 파라미터 기반 상태 계산
  const showPostWrite = window.location.pathname.includes('/write');
  const showPostDetail = !!postId;

  // URL이 변경될 때 현재 게시판 업데이트
  useEffect(() => {
    if (boardId && boardId !== currentBoard) {
      setCurrentBoard(boardId);
    }
  }, [boardId]);

  // postId가 있을 때 selectedPost 설정
  useEffect(() => {
    if (postId && !selectedPost) {
      setSelectedPost({ id: postId, board_id: currentBoard });
    } else if (!postId) {
      setSelectedPost(null);
    }
  }, [postId, currentBoard]);

  const handleBoardChange = (boardId) => {
    setCurrentBoard(boardId);
    navigate(`/board/${boardId}`);
    
    // 모바일에서 게시판 선택 시 사이드바 닫기
    if (window.innerWidth < 768) {
      setSidebarOpen(false);
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // 게시글 클릭 처리 - URL 변경으로 디테일 페이지로 전환
  const handlePostClick = (post) => {
    console.log('🔍 [BoardPage] 게시글 클릭:', post);
    navigate(`/board/${currentBoard}/post/${post.id}`);
  };

  // 디테일 페이지에서 목록으로 돌아가기
  const handleBackToList = () => {
    navigate(`/board/${currentBoard}`);
  };

  // 글쓰기 페이지 열기
  const handleWritePost = () => {
    navigate(`/board/${currentBoard}/write`);
  };

  // 글쓰기 페이지에서 목록으로 돌아가기
  const handleBackFromWrite = () => {
    navigate(`/board/${currentBoard}`);
  };

  // 새 게시글 작성 완료 후 처리
  const handlePostCreated = (newPost) => {
    console.log('🎉 [BoardPage] 새 게시글 작성 완료:', newPost);
    // 작성 완료 후 해당 게시글로 이동
    if (newPost && newPost.id) {
      navigate(`/board/${currentBoard}/post/${newPost.id}`);
    } else {
      navigate(`/board/${currentBoard}`);
    }
  };

  return (
    <div className="board-page">
      <BoardSidebar 
        currentBoard={currentBoard}
        onBoardChange={handleBoardChange}
        isOpen={sidebarOpen}
        onToggle={toggleSidebar}
      />
      <div className="board-main">
        {showPostWrite ? (
          <PostWritePage
            currentBoard={currentBoard}
            onBack={handleBackFromWrite}
            onPostCreated={handlePostCreated}
          />
        ) : showPostDetail ? (
          <PostDetailPage 
            key={`post-${selectedPost?.id}-${currentBoard}`}
            postId={selectedPost?.id}
            boardId={selectedPost?.board_id || currentBoard}
            onBack={handleBackToList}
          />
        ) : (
          <BoardContent 
            currentBoard={currentBoard}
            onToggleSidebar={toggleSidebar}
            onPostClick={handlePostClick}
            onWriteClick={handleWritePost}
          />
        )}
      </div>
    </div>
  );
};

export default BoardPage;